import React, { Component } from 'react';
class CaseDetails extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){
}


  render() {
    return (
        <>
        	<div className="mt-4 mb-4">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">{this.props.page_title}</h3>
                <div className="row g-4">


                <div className="col-md-12">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <form action="" method="post">
                            <div className="row g-3">

                            <div className="col-md-4">
                                <div className="form-floating">
                                    <select class="form-control form-select" id="user_type" name="form_type">
                                    <option value="">Type of Litigation</option>
                                    <option value="Civil">Civil</option>
                                    <option value="Criminal">Criminal</option>
                                    <option value="Family">Family</option>
                                    <option value="Property">Property</option>
                                    <option value="Commercial">Commercial</option>
                                    <option value="IP">IP</option>
                                    <option value="Tax">Tax</option>
                                    <option value="Constitutional">Constitutional</option>
                                    <option value="PIL">PIL</option>
                                    <option value="Arbitration">Arbitration</option>
                                </select>
                                <label for="name">Type of Litigation</label>
                                </div>
                            </div>

                              <div class="col-md-12"><label for="name">Opposing Party Details</label></div>


                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="full_name" placeholder="Name"/>
                                        <label for="name">Name</label>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="gender" placeholder="Address"/>
                                        <label for="name">Address</label>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="gender" placeholder="Contact Information"/>
                                        <label for="name">Contact Information</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="gender" placeholder="Case Number"/>
                                        <label for="name">Case Number</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="bate_of_birth" placeholder="Court / Tribunal / Forum Name"/>
                                        <label for="name">Court / Tribunal / Forum Name</label>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="form-floating">
                                        <textarea className="form-control textarea-height" placeholder="Nature of Dispute &amp; Background" id="message" name="message" maxlength="250"></textarea>
                                        <label for="name">Nature of Dispute &amp; Background</label>
                                    </div>
                                </div>


                                <div className="col-md-12">
                                  <div className="col-md-2 p-0">
                                      <button className="btn btn-primary w-100 py-3" type="button">Submit</button>
                                  </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>

        </>
    );
  }
}

export default CaseDetails;
